<template>
    <div class="card-content">
        <div class="mgb-40px mgr-10px">
          <div class="has-text-right"
            v-if="tiers.typologie === constantes.TYPOLOGIE_POINT_DE_VENTE">
              <a class="button is-primary"
                @click="popUpAjoutContactEnseigne = true"
                :class="{ 'button-access-no-permission' : !checkPermissions(permsTiers.maj) }"
              >
                {{ $t('detailContact.button.addContactFromEnseigne')}}
              </a>
          </div>
        </div>
        <div>
            <contact-card class="mgb-20px" :key="contact.id"
            v-for="contact in listePortail" :contact="contact"
                :isFromBailleur="false" :isPortail="true">
            </contact-card>
        </div>
        <b-modal
          v-model="popUpAjoutContactEnseigne"
          has-modal-card
          width="800px" class="modal">

          <ajout-contacts-tiers
            :tiersFromId="idToPass()"
            :tiersToId="tiers.id"
            @update="onAjoutContactTiers"
            :currentContacts="listePortail"
          />
        </b-modal>
    </div>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';
import { TIERS } from '@/configuration/permissionsBodacConf';
import contactCard from '@/components/tiers/contacts/contactCard';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { getAllByTiers } from '@/api/contactTiers/index';
import { TYPOLOGIE_POINT_DE_VENTE } from '@/configuration/tiers/tiersConf';
import ajoutContactsTiers from '@/components/tiers/contacts/p_ajoutContactsTiers';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'ContactPortail',
  props: {
    tiers: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      permsTiers: TIERS,
      listePortail: [],
      popUpAjoutContactEnseigne: false,
      constantes: {
        TYPOLOGIE_POINT_DE_VENTE,
      },
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
  },
  components: {
    contactCard,
    ajoutContactsTiers,
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    onAjoutContactTiers() {
      this.popUpAjoutContactEnseigne = false;
      this.refresh();
    },
    idToPass() {
      return this.tiers.tiersParent && this.tiers.tiersParent.id
        ? this.tiers.tiersParent.id : this.tiers.id;
    },
    async refresh() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametres([PARAMETRES_KEYS.civilite]);
        const listeContactPortail = await getAllByTiers(this.tiers.id);
        this.listePortail = listeContactPortail.data.result.items;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    await this.refresh();
  },
};
</script>
